import { useCallback, useState } from 'react';

export interface UploadTask {
  id: string;
  filename: string;
  bucket: string;
  progress: number;
  status: 'uploading' | 'success' | 'error';
  startTime: number;
  endTime?: number;
  error?: string;
}

export default () => {
  const [uploads, setUploads] = useState<UploadTask[]>([]);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const addUpload = useCallback(
    (task: Omit<UploadTask, 'progress' | 'status' | 'startTime'>) => {
      setUploads((prev) => [
        {
          ...task,
          progress: 0,
          status: 'uploading',
          startTime: Date.now(),
        },
        ...prev,
      ]);
    },
    [],
  );

  const updateProgress = useCallback((id: string, progress: number) => {
    setUploads((prev) =>
      prev.map((item) => (item.id === id ? { ...item, progress } : item)),
    );
  }, []);

  const completeUpload = useCallback((id: string) => {
    setUploads((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, progress: 100, status: 'success', endTime: Date.now() }
          : item,
      ),
    );
  }, []);

  const failUpload = useCallback((id: string, error?: string) => {
    setUploads((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, status: 'error', endTime: Date.now(), error }
          : item,
      ),
    );
  }, []);

  const showDrawer = useCallback(() => setDrawerVisible(true), []);
  const hideDrawer = useCallback(() => setDrawerVisible(false), []);

  return {
    uploads,
    drawerVisible,
    addUpload,
    updateProgress,
    completeUpload,
    failUpload,
    showDrawer,
    hideDrawer,
  };
};
